import React from "react"
import "./WhoWeServePage.css"

const WhoWeServePage = () => {
  return (
    <div className="epw-serve-page">

      <main>
        <header className="epw-hero">
          <div className="epw-wrap">
            <p className="epw-eyebrow">Who We Serve</p>
            <h1>Intelligence for organizations exposed to energy, cost and trade dynamics.</h1>
            <p>
              EnergyPulseWorld is designed for decision-makers who need a clearer view of how
              energy developments can influence markets, production costs, supply chains,
              investment and international trade.
            </p>
          </div>
        </header>

        <section className="epw-main">
          <div className="epw-wrap">

            <div className="epw-grid">
              <article className="epw-card">
                <h2>Energy Companies</h2>
                <p>Track regional demand, market exposure, industrial impact and changing energy structures.</p>
              </article>

              <article className="epw-card">
                <h2>Manufacturers &amp; Heavy Industry</h2>
                <p>Monitor energy-sensitive costs affecting fertilizers, steel, aluminium, cement and production competitiveness.</p>
              </article>

              <article className="epw-card">
                <h2>Banks &amp; Investors</h2>
                <p>Use economic, energy and trade indicators to support country screening, risk assessment and investment analysis.</p>
              </article>

              <article className="epw-card">
                <h2>Consulting &amp; Advisory Firms</h2>
                <p>Strengthen market research with comparable country indicators, weekly insights and exportable intelligence.</p>
              </article>

              <article className="epw-card">
                <h2>Trade, Logistics &amp; Supply Chains</h2>
                <p>Assess import exposure, commodity trends, trade administration and potential disruption risks.</p>
              </article>

              <article className="epw-card">
                <h2>Public &amp; Policy Institutions</h2>
                <p>Monitor macroeconomic, energy and trade developments with a regional and cross-market perspective.</p>
              </article>
            </div>

            <section className="epw-usecases">
              <h2>How EnergyPulseWorld can support your work</h2>

              <div className="epw-usecase-grid">
                <div className="epw-usecase">
                  <strong>Market Monitoring</strong>
                  <span>Track changing energy, economic and commodity conditions.</span>
                </div>

                <div className="epw-usecase">
                  <strong>Country Comparison</strong>
                  <span>Compare markets using consistent macroeconomic, energy and trade indicators.</span>
                </div>

                <div className="epw-usecase">
                  <strong>Risk Assessment</strong>
                  <span>Identify exposure to energy shocks, imports, inflation and trade constraints.</span>
                </div>

                <div className="epw-usecase">
                  <strong>Strategic Planning</strong>
                  <span>Translate market developments into business and investment context.</span>
                </div>
              </div>
            </section>

            <section className="epw-cta-box">
              <div>
                <h2>Choose the level of access that fits your organization.</h2>
                <p>
                  Pro provides current premium intelligence, while Enterprise adds archive access,
                  downloads, exports, charts and infographics for organizational use.
                </p>
              </div>

              <a className="epw-cta" href="/login">View Subscription Options</a>
            </section>

          </div>
        </section>
      </main>
    </div>
  )
}

export default WhoWeServePage
